import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useHistory } from "react-router";
import { useDrag } from "react-dnd";
import CompassIcon from "../../helpers/CompassIcon";
import DraggingTransfer from "../DraggingTransfer";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Targets } from "../../../../common/dndHelper";
import { IDropResult, TimelineCommandType } from "../../types/plannerTypes";
import { getShortFullName } from "../plannerHelpers";
import { getLastVersionVisualState, mapFromIScheduleToSingleVirtualTrip } from "../virtualTripHelpers";
import { useDispatch } from "react-redux";
import { showTripDetailsModal } from "../../../../store/modules/plannerSliceModals";
import { MODAL_TYPE } from "../PlannerTripDetails";
import { NeedIcon, NeedListItem, AcuityNeedItem, PriorityBadge } from "../../TransferIcons";
import { getOriginLocationString, getDestinationLocationString, getTimeFromDate } from "../../../../common/helpers";
import { setLoading } from "../../../../store/modules/plannerLoadingSlice";
import api from "../../../../store/api";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { getData, getRoles, persistName, setData } from "../../helpers/transferScheduleHelpers";
import { consts } from "../../../../common/consts";
import { checkAcuity, checkuserpermission, checkuserpermissionforAdhoc } from "../../conflictNotices/conflictNoticeHelper";


const Status = ({
  rolesAndFeatures,
  setCurrentTransferId,
  setCurrentBookingId,
  setShowVehicleModal,
  setCurrentTransferData,
  setShowScheduleModalAssignVehicleOption,
  setShowScheduleModal,
  transfer,
}: any) => {
    const classes = useStyles();

    if (transfer.status == 3) {
        return <>In Progress</>;
    } else if (transfer.status == 4) {
        return <>Complete</>;
    } else if (transfer.status == 6) {
        return <>Aborted</>;
    } else if (transfer.status == 7) {
        return <>Picking Up</>;
    } else if (transfer.status == 8) {
        return <>EnRoute To Destination</>;
    } else if (transfer.status == 9) {
        return <>Dropping Off</>;
    } else if (transfer.status == 10) {
        return <>Completed</>;
    } else if (transfer.status == 11) {
        return <>Cancelled</>;
    }
  else if (transfer.assignedToMe) {
    return <>Assigned To Me</>;
  } else if (transfer.assignedVehicle) {
    return <>Assigned to {transfer.assignedVehicle}</>;
  } else if (transfer.status == 2) {
    return (
      <>
        Scheduled{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentTransferId(transfer.transferId);
            setCurrentBookingId(transfer.bookingId);
            setShowVehicleModal(true);
          }}
          className={classes.yellowBoxText}
        >
          Assign
        </span>
      </>
    );
  } 
   else if (rolesAndFeatures.isAdmin || (rolesAndFeatures.isSMADriver && rolesAndFeatures.isVehicleAllocated)) {
    return (
      <>
        Requested{" "}
        <span
          onClick={(e: any) => {
            e.stopPropagation();
            setCurrentTransferId(transfer.transferId);
            setCurrentTransferData(transfer);
            setCurrentBookingId(transfer.bookingId);
            setShowScheduleModalAssignVehicleOption(true);
            setShowScheduleModal(true);
          }}
          className={classes.yellowBoxText}
        >
          Schedule
        </span>
      </>
    );
  } else {
    return <>Requested</>;
  }
};

const AdHocTransferItem = (props: any) => {
  const {
    transferRequest,
    updatedTransfers,
    roles,
    setCurrentTransferId,
    setCurrentBookingId,
    setShowVehicleModal,
    setErrorMessage,
    setCurrentTransferData,
    setShowScheduleModal,
    setShowScheduleModalAssignVehicleOption,
    setConflictDialogData
  } = props;

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
    const canBeDragged = roles.canRequestAdHocTransfer ? (transferRequest.isPlannerDraggable || false) : false;
    const { authStore } = useSelector((state: RootState) => state);
    const [role, setRoles] = React.useState<any>(getRoles(authStore));

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: "TransferRequest",
    item: { transferId: transferRequest.transferId, mobility: transferRequest.mobility, transferAcuity: transferRequest?.classification },
    canDrag: canBeDragged,
    end: async (item, monitor) => {
      const dropResult = monitor.getDropResult() as IDropResult;
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
      if (item && dropResult && dropResult.target === Targets.REQUESTED) {
        dispatch(setLoading(true));
        const res = await api.cancelAdHocRequest("", { transferId: item.transferId });
        if (res.hasError) {
          setErrorMessage(res.message || "Error moving ad-hoc request");
        }
        dispatch(setLoading(false));
        return;
      }
      if (dropResult && dropResult.target === Targets.PLANNER_TIMELINE) {
        if (dropResult?.plannerMinute?.trip) {
          // mostly insurance that it take last version of the trip
          const lastVersionOfTrip = getLastVersionVisualState().find((v) => v.virtualTripId === dropResult.plannerMinute?.trip?.virtualTripId);
          var updatedLastVersionOfTrip:any={...lastVersionOfTrip};
          if (lastVersionOfTrip && updatedLastVersionOfTrip) {
            updatedLastVersionOfTrip.isTripMinOverrided = false;
            updatedLastVersionOfTrip.overrideTripEstimateInMin = 0;
          }
          dropResult.applyTimelineChanges(mapFromIScheduleToSingleVirtualTrip(transferRequest), {
            type: TimelineCommandType.addToTrip,
            tripUpdates: updatedLastVersionOfTrip,
          });
          return;
        } else {
          dropResult.applyTimelineChanges(mapFromIScheduleToSingleVirtualTrip(transferRequest), {
            type: TimelineCommandType.moveTrip,
            plannerMinute: dropResult.plannerMinute,
          });
          return;
        }
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  React.useEffect(() => {
    preview(getEmptyImage());
  }, []);

  const transferStatusText = () => {
    switch (transferRequest.status) {
      case 3:
        return "In Progress";
      case 4:
      case 10:
        return "Completed";
      case 6:
        return "Aborted";
      case 7:
        return "in status Picking Up";
      case 8:
        return "in status EnRoute To Destination";
      case 9:
        return "in status Dropping Off";
      case 11:
        return "Cancelled";
      default:
        return null;
    }
  };

  return (
    <>
      <Tooltip title={canBeDragged || !transferStatusText() ? "" : `This transfer is ${transferStatusText()} and can no longer be modified`}>
        <div
          className={clsx(classes.tableRow, {
            [classes.animatedUpdatedItem]: updatedTransfers.some(
              (e: any) => e.TransferId === transferRequest.transferId && new Date().getTime() - e.UpdatedDate < 60000
            ),
            [classes.isDragging]: isDragging,
          })}
          onClick={(e) => history.push(`/transferDetails/${transferRequest.bookingId}/${transferRequest.transferId}`)}
          ref={drag}
        >
          <div className={classes.multiLoadColumn}></div>
          <div className={classes.pickupTimeColumn}>{transferRequest.status == 13 ? "-" : getTimeFromDate(transferRequest.scheduledDate)}</div>
          <div className={classes.patientColumn}>
            {transferRequest.firstName[0]} {transferRequest.lastName}
          </div>
          <div className={classes.needsColumn}>
            {transferRequest.bookingSpecialNeeds.map((item: any) => (
              <NeedIcon
                key={transferRequest.bookingId + item.specialNeedId}
                iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
              />
            ))}
            {transferRequest.mobility === 1 && <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />}
            {transferRequest.mobility !== 1 && <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />}
            {transferRequest.classification && <AcuityNeedItem key="acuity" text={transferRequest.classification} />}
          </div>
          <div className={classes.fromColumn}>{getOriginLocationString(transferRequest, true)}</div>
          <div className={classes.toColumn}>
            <span style={{ float: "left" }}>
              <CompassIcon angle={transferRequest.bearingAngle || 0} theme={"dark"} />
            </span>
            {getDestinationLocationString(transferRequest, true)}
          </div>
          <div className={classes.priorityColumn}>
            <PriorityBadge priority={transferRequest.priority} />
          </div>
          <div className={classes.statusColumn}>
            <Status
              rolesAndFeatures={roles}
              transfer={transferRequest}
              setCurrentTransferId={setCurrentTransferId}
              setCurrentBookingId={setCurrentBookingId}
              setCurrentTransferData={setCurrentTransferData}
              setShowVehicleModal={setShowVehicleModal}
              setShowScheduleModalAssignVehicleOption={setShowScheduleModalAssignVehicleOption}
              setShowScheduleModal={setShowScheduleModal}
            />
          </div>
          <div className={classes.actionButtonColumn}>
            <IconButton aria-label="expand row" size="small">
              <ArrowForwardIosIcon style={{ fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      </Tooltip>

      {isDragging && (
        <DraggingTransfer name={getShortFullName(transferRequest.firstName, transferRequest.lastName)} 
        adjustForTransferRequest={true} Draglocation ={null} selectedLocationId={null}/>
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    fontWeight: 500,
    backgroundColor: "rgb(2, 72, 157, 0.23)",
    height: 45,
    minHeight: 45,
    maxHeight: 45,
    fontSize: "18px",
    lineHeight: "22px",
    borderTop: "1px solid #00152E",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },

    "&:not(:last-child)": {
      borderBottom: "1px solid #00152E",
    },
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    height: 33,
  },
  animatedUpdatedItem: {
    animation: `$updatedTransferEffect 60000ms ease-out`,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08) !important",
    },
  },
  "@keyframes updatedTransferEffect": {
    "0%": { backgroundColor: "#F4B8273A" },
    "100%": { backgroundColor: "#002047" },
  },
  multiLoadColumn: {
    flex: "0 0 53px",
    display: "flex",
    justifyContent: "center",
    height: "100%",
  },
  patientColumn: {
    paddingLeft: 10,
    flex: "1 1 169px",
    display: "flex",

    "& span": {
      color: "#010B18",
      opacity: "0.39",
    },

    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  pickupTimeColumn: {
    paddingLeft: 15,
    flex: "0 0 171px",
  },
  needsColumn: {
    paddingLeft: 15,
    flex: "0 0 164px",
    display: "flex",
    alignItems: "center",

    "& img": {
      width: 18,
      height: 18,
    },
    "@media (max-width: 1280px)": {
      display: "none",
    },
  },
  fromColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toColumn: {
    paddingLeft: 15,
    flex: "1 1 248px",
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  priorityColumn: {
    flex: "0 0 47px",
  },
  statusColumn: {
    flex: "1 1 245px",
  },
  actionButtonColumn: {
    paddingLeft: 15,
    paddingRight: 10,
    flex: "0 0 32px",
    display: "flex",
    justifyContent: "flex-end",
  },
  isDragging: {
    opacity: 0.2,
  },

  //   requestText: {
  //     marginRight: 10,
  //     paddingTop: 4,
  //     float: "left",
  //   },
  yellowBoxText: {
    background: "#F4B827",
    padding: "6px 16px",
    fontSize: 14,
    fontWeight: 700,
    color: "#03090E",
    borderRadius: 4,
    marginLeft: 5,
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

export default AdHocTransferItem;
